import { Routes } from '@angular/router';

import { authGuard, guestGuard } from '@movilidad/app-core';

import { DataResolverService } from './resolver/data-resolver.service';
import { captureBirthdayGuard } from './services/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/initial', pathMatch: 'full' },
  {
    path: 'initial',
    data: { navBar: 'dark' },
    loadComponent: () => import('./initial/initial.page').then((m) => m.InitialPage),
    canActivate: [guestGuard],
  },
  {
    path: 'login',
    data: { navBar: 'dark' },
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
    canActivate: [guestGuard],
  },
  {
    path: 'tecservice-transportec',
    loadChildren: () => import('./tabs-transportec/transportec.routes').then((m) => m.transportecRoutes),
    canActivate: [authGuard],
  },
  {
    path: 'tecservice-driver',
    loadChildren: () => import('./tabs-driver/driver.routes').then((m) => m.driverRoutes),
    canActivate: [authGuard],
  },
  {
    path: 'preregister',
    data: { navBar: 'dark' },
    loadComponent: () => import('./preregister/preregister.page').then((m) => m.PreregisterPage),
  },
  {
    path: 'register',
    data: { navBar: 'dark' },
    children: [
      {
        path: '',
        loadComponent: () => import('./register/register.page').then((m) => m.RegisterPage),
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            resolve: {
              special: DataResolverService,
            },
            loadComponent: () => import('./register/register.page').then((m) => m.RegisterPage),
          },
        ],
      },
    ],
  },
  {
    path: 'forgot-password',
    data: { navBar: 'dark' },
    loadComponent: () => import('./forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
  },
  {
    path: 'email-confirmation',
    data: { navBar: 'dark' },
    loadComponent: () => import('./email-confirmation/email-confirmation.page').then((m) => m.EmailConfirmationPage),
  },
  {
    path: 'capture-birthday',
    data: { navBar: 'dark' },
    loadComponent: () => import('./capture-birthday/capture-birthday.page').then((m) => m.CaptureBirthdayPage),
    canActivate: [captureBirthdayGuard],
  },
  {
    path: 'scan',
    data: { topBar: 'light' },
    loadComponent: () => import('./scan/scan.page').then((m) => m.ScanPage),
  },
  {
    path: 'payment-card',
    data: { topBar: 'light' },
    loadComponent: () =>
      import('./tabs-transportec/wallet/payment-card/payment-card.page').then((m) => m.PaymentCardPage),
  },
  {
    path: '**',
    redirectTo: '/initial',
  },
];
